import { Tooltip as MuiTooltip, TooltipProps } from '@material-ui/core';

export const Tooltip: React.FC<TooltipProps> = (props) => {
  return <MuiTooltip {...props} />;
};
